// extracted by mini-css-extract-plugin
export var modal = "_gj-0";